import './index.scss'

export default function Footer(){
    return(
        <div className="footer-geral">

            <div className='footer-interno'>
                <h3>Matematicos</h3>

                <div className='imgDiv'>
                    <img src='./assets/images/iconCalc.png' alt="Ícone matematicos"/>
                </div>
            </div>
            
        </div>
    );
}